var exports = {
  "rF": "smallToken__0gOjpn",
  "nF": "IssueTypeToken__qMFcEW",
};

module.exports = exports;
